// extracted by mini-css-extract-plugin
export default {"error":"tClSdOE1Kutm4_8yhPuc","changePassword":"ozauhNEjML2ldL5Vbio_","changePasswordCard":"ebUwyohVX8xz8DEJ8Idq"};